<template>
  <el-dialog
    title="提案数据批量修改窗口"
    :visible.sync="visible"
    width="1200px"
    @close="close">

    <el-form :inline="true" :model="searchParams" label-position="right">
      <el-form-item label="公开">
        <el-select size='mini' v-model="searchParams.isopenum" style="width:100px;" filterable :placeholder="$t('proposal.isopen')" clearable>
                <el-option
                    v-for="item in Iopen"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
          </el-select>
      </el-form-item>

      <el-form-item label="">
        <el-select size='mini' v-model="searchParams.currentStatus" style="width:120px;" filterable :placeholder="$t('proposal.status')" clearable>
                <el-option
                    v-for="item in datastatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
          </el-select>
      </el-form-item>
      <el-form-item>
        <el-button   type="primary" @click="ok">修改</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      style="width: 100%;">
      <el-table-column
        prop="id"
        label="ID"
        v-if="false">
      </el-table-column>
      <el-table-column
        fixed
        prop="obs_id"
        label="观测号">        
      </el-table-column>
      <el-table-column
        prop="status"
        label="数据状态">
      </el-table-column>
      <el-table-column
        prop="isopen"
        label="公开">
      </el-table-column>
    </el-table>  
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <!-- <el-button type="primary" @click="ok">确定</el-button> -->
    </div>

  </el-dialog>
</template>

<script>
import {datastatus,Iopen} from '../common';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Array,
      default(){
        return [];
      },
    },
  },
  data() {
    return {
      searchParams:{
        isopenum:'', 
        currentStatus:'',
      },
      list:[],
      Iopen:Iopen,
      datastatus: datastatus,
      visible: false,
    };
  },
  watch: {
    dialogVisible(val) {
      // console.log("dialogVisible传入数据在这里",val);
      this.visible = val;
    },
    dialogData(data){
      this.list = data;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    ok() {
      if(this.searchParams.isopenum===''&&this.searchParams.currentStatus===''){
        alert('请至少选择一项[公开]或者[数据状态]进行批量修改!');
        return;
      }
      this.$emit('ok', {
        ...this.searchParams,
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
